const profilePath = '/profile';
export default profilePath;

export const profileTabGroupPath = `${profilePath}/user-groups`;
export const profileRadPermissionsPath = `${profilePath}/rad-permissions`;
